import React, {Component} from 'react'
import styles from './Feature.css'
import Button from '../Button'
import SlideShow from '../SlideShow'
import ScrollArrow from '../ScrollArrow'
import Vimeo from '../Vimeo'
import Modal from '../Modal'
import PlayButton from '../PlayButton'

export default class Feature extends Component {
  state = {
    showModal: false,
  }

  startFeatureVideo = () => {
    this.setState({showModal: true})
  }

  quitModal = () => {
    this.setState({showModal: false})
  }

  render () {
    return (
      <div className={styles.cont} style={{
        backgroundImage: this.props.image ? 'url('+this.props.image+')' : '',
      }}>
      {this.props.backgroundVideo && (
        <div className={styles.slideShow}>
          <Vimeo video={this.props.backgroundVideo} noImage/>
        </div>
        )}

        {this.props.images && (
          <div className={styles.slideShow}>
            <SlideShow slideShow={this.props.images}/>
          </div>
        )}


        <div className={styles.innerCont} style={{
          height: (window.innerHeight - 81) + 'px',
        }}>
          <div className={styles.primaryTitle +' '+ styles.title}>
            {this.props.primaryTitle}
          </div>
          <div className={styles.secondaryTitle +' '+ styles.title}>
            {this.props.secondaryTitle}
          </div>
          <div className={styles.right}>
            <div className={styles.title}>
              <div>
                {this.props.start}
              </div>
              <div className={styles.clearfix}>
                <div className={styles.sep}/>
              </div>
              <div>
                {this.props.end}
              </div>
            </div>
          </div>
          <div className={styles.playButtonCont}>
            <div onClick={this.startFeatureVideo} className={styles.playButton}>
              <PlayButton/>
            </div>
          </div>
        </div>

        {
          this.props.description && (
            <div className={styles.left}>
              <div className={styles.featureDetail}>
                <div className={styles.description}>
                  {this.props.description}
                </div>
                <div className={styles.buttons}>
                  <a href={this.props.bookingLink}>
                    <Button theme='white'>About the artworks</Button>
                  </a>
                </div>
              </div>
            </div>
            )
        } 

        <div className={styles.scrollArrowCont}>
          <ScrollArrow to='/#About'/>
        </div>


        {
          this.state.showModal && <FeatureVideo quitModal={this.quitModal} video={this.props.video}/>
        }

      </div>
    )
  }
}

class FeatureVideo extends Component {
  handleResize = () => {
    this.setState({width: document.body.scrollWidth, height: window.innerHeight})
  }
  componentDidMount () {
    window.addEventListener('resize', this.handleResize)
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }
  render () {
    return (
      <Modal quitModal={this.props.quitModal}>
        <div className={styles.video}>
          <div className={styles.slide} style={{
            width: document.body.scrollWidth,
            height: window.innerHeight,
          }}>
            <div className={styles.img}>
              <Vimeo video={this.props.video} noImage/>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Feature/index.js